import { Ref } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "~/lib/utils";

export interface SkeletonProps extends Omit<React.ComponentProps<"div">, "ref"> {
  asChild?: boolean;
  ref?: Ref<HTMLElement>;
}

function Skeleton({ className, ref, asChild = false, ...props }: SkeletonProps) {
  const Comp = asChild ? Slot : "div";

  return (
    <Comp
      ref={ref as typeof asChild extends true ? Ref<HTMLElement> : Ref<HTMLDivElement>}
      data-slot="skeleton"
      className={cn(
        "bg-neutral-200 animate-pulse [animation-duration:1.5s] [animation-delay:0.5s] rounded-md",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
